var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5326 18.9638H5.03757V4.46873C5.03757 4.15982 4.77618 3.89844 4.46727 3.89844C4.15836 3.89844 3.89697 4.15982 3.89697 4.46873V19.5341C3.89697 19.843 4.15836 20.1044 4.46727 20.1044H19.5326C19.8415 20.1044 20.1029 19.843 20.1029 19.5341C20.1029 19.2252 19.8415 18.9638 19.5326 18.9638Z",
    fill: "#D0004B",
    stroke: "#D0004B",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5743 16.753V8.53123C10.5743 8.22232 10.3129 7.96094 10.004 7.96094C9.69507 7.96094 9.43368 8.22232 9.43368 8.53123V16.7768C9.43368 17.0857 9.69507 17.3471 10.004 17.3471C10.3129 17.3471 10.5743 17.0857 10.5743 16.753ZM7.81784 16.753V8.53123C7.81784 8.22232 7.55645 7.96094 7.24754 7.96094C6.93863 7.96094 6.67725 8.22232 6.67725 8.53123V16.7768C6.67725 17.0857 6.93863 17.3471 7.24754 17.3471C7.55645 17.3233 7.81784 17.0857 7.81784 16.753ZM16.1109 16.753V8.53123C16.1109 8.22232 15.8495 7.96094 15.5406 7.96094C15.2317 7.96094 14.9703 8.22232 14.9703 8.53123V16.7768C14.9703 17.0857 15.2317 17.3471 15.5406 17.3471C15.8495 17.3233 16.1109 17.0857 16.1109 16.753ZM18.8673 16.753V12.6421C18.8673 12.3332 18.606 12.0718 18.297 12.0718C17.9881 12.0718 17.7268 12.3332 17.7268 12.6421V16.753C17.7268 17.0619 17.9881 17.3233 18.297 17.3233C18.606 17.3233 18.8673 17.0857 18.8673 16.753ZM13.3307 16.753V12.6421C13.3307 12.3332 13.0693 12.0718 12.7604 12.0718C12.4515 12.0718 12.1901 12.3332 12.1901 12.6421V16.753C12.1901 17.0619 12.4515 17.3233 12.7604 17.3233C13.0693 17.3233 13.3307 17.0857 13.3307 16.753Z",
    fill: "#D0004B",
    stroke: "#D0004B",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGraph);
export default __webpack_public_path__ + "static/media/tableGraph.839c882b9de87c8b3e666c561b11623c.svg";
export { ForwardRef as ReactComponent };